<template>
    <a-modal
        :class="$style.root"
        title="用户登录"
        v-model="isVisible"
        :confirm-loading="isLoading"
        :footer="false"
        centered>
        <a-spin :spinning="isLoading">
            <a-form :form="form" @keyup.enter.native="onSubmit">
                <a-form-item>
                    <a-input size="large" placeholder="请输入账号" v-decorator="['username', formFields.account]">
                        <template #prefix>
                            <font-icon type="icon-yonghu" />
                        </template>
                    </a-input>
                </a-form-item>
                <a-form-item>
                    <a-input-password
                        size="large"
                        placeholder="请输入密码"
                        v-decorator="['password', formFields.password]">
                        <template #prefix>
                            <font-icon type="icon-mima" />
                        </template>
                    </a-input-password>
                </a-form-item>
            </a-form>
            <div class="columns">
            </div>
            <div class="columns">
                <a-button size="large" type="primary" class="column" block @click="onSubmit">登录</a-button>
                <div class="whitespace"></div>
            </div>
        </a-spin>
    </a-modal>
</template>

<script>
    import { mapActions } from 'vuex';

    import eventBus from '../../utils/eventBus';

    export default {
        name: 'DefectRecordDialog',

        data() {
            return {
                form: this.$form.createForm(this),
                isLoading: false,
                isVisible: false,
                formFields: {
                    account: {
                        validateFirst: true,
                        validateTrigger: ['blur', 'change'],
                        rules: [{ required: true, message: '请输入用户名', whitespace: true }],
                    },
                    password: {
                        validateTrigger: ['blur', 'change'],
                        rules: [
                            { required: true, message: '请输入密码' },
                        ],
                    },
                },
            };
        },

        mounted() {
            eventBus.$on('show-login-dialog', (show) => {
                this.isVisible = show;
            });
        },

        destroyed() {
            eventBus.$off('show-login-dialog');
        },

        methods: {
            ...mapActions(['requestPasswordLogin', 'gerUserInfo']),

            // 提交表单
            onSubmit() {
                this.form.validateFields((err, values) => {
                    if (err) return;
                    this.requestPasswordLogin(values)
                        .then((res) => {
                            console.log(res)
                            
                            if (res.data) {
                                this.onReset();

                                this.$message.success('登录成功');
                                this.isVisible = false;
                                this.$router.go(0);
                            } else {
                                this.$message.error('登录失败,用户名或密码错误');
                            }
                        })
                        .catch(({ message }) => {
                            // this.onRefreshCode();
                            this.isVisible = false;
                            if (message) this.$message.error('登录失败,用户名或密码错误');
                        });
                });
            },

            onReset() {
                this.form.resetFields();
            },
        },
    };
</script>

<style lang="less" module>
    .root {
        :global {
            .ant-modal-header {
                text-align: center;
            }
        }
    }
</style>
